import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c4403ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "signup-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "xr-icon-xarcade h1",
    style: {"font-size":"60px"}
  })
], -1))
const _hoisted_4 = {
  class: "mb-4 text-white lh-5",
  style: {"line-height":"2"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-5 text-gray-text text-2xl" }, "Account Creation Successful!", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xr-icon-check my-4 text-blue-primary",
  style: {"font-size":"4em"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "my-4 text-gray-text text-md" }, "We've sent a link to your email for account verification.", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Sign In")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _hoisted_3,
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.companyName), 1),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: { name: 'viewAuthLogin' },
            class: "btn-primary-full"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_authFooter)
      ])
    ])
  ]))
}